<template>
  <div>
    <v-container fluid style="margin-top:0px;margin-bottom:0px">
      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field 
            v-model="search" 
            append-icon="search" 
            :label="$t('Buscar')" 
            single-line 
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table 
          :headers="headers" 
          :items="list" 
          :search="search" 
          :loading="loading" 
          :loading-text="$t('cargando_espere')" 
          hide-default-footer 
          disable-pagination
        >
          <template v-slot:item="props">
            <tr>
              <td>
                {{ props.index + 1 }}
              </td>
              <td>{{ props.item.numContainer || '-' }}</td>
              <td>{{ props.item.warehouse ? props.item.warehouse.nameWarehouse : '-' }}</td>
              <td>{{ props.item.origen ? props.item.origen.origen : '-' }}</td>
              <td class="text-center">{{ props.item.viajeIngreso ? '#'+props.item.viajeIngreso.numTrip : '-' }}</td>
              <td class="text-center">
                <v-chip small :color="props.item.isAvailable ? 'green' : 'red'" text-color="white">
                  {{ props.item.isAvailable ? 'SI' : 'NO' }}
                </v-chip>
              </td>
              <td class="text-center">{{ props.item.products ? props.item.products.length : 0 }}</td>
              <td class="text-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon 
                      v-on="on" 
                      small 
                      color="blue" 
                      class="mr-1" 
                      @click="viewItem(props.item)"
                    >
                      remove_red_eye
                    </v-icon>
                  </template>
                  <span>{{ $t("Ver") }}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning"> 
              {{ $t("sin_resultados") + search }}". 
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete 
        :dialog_delete="dialog_delete" 
        @updateDialogDelete="updateDialogDelete" 
        @deleteItemConfirm="deleteItemConfirm" 
      />
    </v-container>
  </div>
</template>

<script>
import { contenedoresService } from "@/libs/ws/contenedoresService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import RolMixin from "@/mixins/RolMixin.vue";

export default {
  components: { DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      parent: this,
      service: contenedoresService,
      page_title: "Contenedores",
      modal_title: "Contenedor",
      mainItem: {
        id: "",
        containerNumber: "",
        description: "",
        type: "",
        status: "",
      },
      defaultItem: null,
      headers: [
        { text: this.$t("Numero"), value: "number" },
        {
          text: "Número de Contenedor",
          align: "left",
          sortable: true,
          value: "numContainer",
        },
        {
          text: "Warehouse",
          align: "left",
          sortable: true,
          value: "warehouse.nameWarehouse",
        },
        {
          text: "Origen",
          align: "left",
          sortable: true,
          value: "origen.origen",
        },
        {
          text: "Ruta Ingreso",
          align: "center",
          sortable: true,
          value: "viajeIngreso.numTrip",
        },
        {
          text: "Disponible",
          align: "center",
          sortable: true,
          value: "isAvailable",
        },
        {
          text: "Productos",
          align: "center",
          sortable: false,
          value: "products",
        },
        { text: this.$t("Accion"), value: "enable", align: "center" },
      ],
      list: [],
    };
  },
  mounted() {
    this.defaultItem = Object.assign({}, this.mainItem);
    this.loadList();
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service);
    },
    loadList() {
      this.loading = true;
      
      this.service.getAllContainers()
        .then((response) => {
          this.list = response.list;
          console.log("Contenedores list", this.list);

          if (this.selected != undefined) {
            this.selected = [];
          }

          this.loading = false;
        })
        .catch((e) => {
          console.log("service.getAllContainers error", e);
          this.loading = false;
          this.$toast.error("Error al cargar contenedores");
        });
    },
  },
};
</script>
